
enum PERSON_ON_BOARD_TYPES {
    CREW,
    PAX
}

enum ORGANIZATION_TYPES {
    AUTHORITY,
    RSO,
    AGENT_COMPANY,
    All
}

enum LOCATION_SOURCES {
    IMO_INTERNAL,
    IMO_EXTERNAL
}

enum SHIP_STATUSES {
    TO_BE_PROCESSED,
    INACTIVE,
    ACTIVE
}

enum UPLOAD_TYPES {
    CREW,
    PAX,
    CREW_AND_PAX,
    SHIP_STORES
  }

  enum SHIP_STORE_ERRORS {
      QUANTITY,
      NAME_OF_ARTICLE
  }

export { PERSON_ON_BOARD_TYPES, ORGANIZATION_TYPES, LOCATION_SOURCES, SHIP_STATUSES, SHIP_STORE_ERRORS, UPLOAD_TYPES };



// WEBPACK FOOTER //
// ./src/app/shared/constants/enumValues.ts